// import { QrModalComponent } from '@features/qr-modal/qr-modal.component';
import { QrModalComponent } from '@features/qr-modal/qr-modal.component';
import { ToasterIcon } from './../enum/toster-enum';
import { ToasterPosition } from './../enum/toster-enum';

import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector } from '@angular/core';
import { QrServiceComponent } from '@page/products/qr/qr-service/qr-service.component';
import { ToastrService } from 'ngx-toastr';
// import Swal from 'sweetalert2';
import { filter, Observable, Subject } from 'rxjs';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { Router } from '@angular/router';
;
import { AppData } from './app-data.service';

export enum TYPE {
  ERROR='error',
  SUCCESS='success',
  WARNING='warning',
  INFO='info',
  QUESTION='question'
}


@Injectable({
  providedIn: 'root'
})

export class TosterService {

  private subject = new Subject<Alert>();
  private defaultId = 'default-alert';

  private dynamicComponentRef: ComponentRef<QrModalComponent> | null = null;

  constructor(private toastr: ToastrService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef, private router: Router, ) { }

  showSuccess(message: any, title?: any) {
    let toasterConfig = {
      positionClass: 'toast-bottom-center'
    }
    this.toastr.success(message, undefined, toasterConfig);
  }

  showError(message: any, title?: any, timeOut?: any) {
    let toasterConfig = {
      positionClass: 'toast-bottom-center',
      timeOut: timeOut ?? 10000,
      title: title
    }
    this.toastr.error(message, '', toasterConfig);
  }

  showInfo(message: any, title?: any) {
    let toasterConfig = {
      positionClass: 'toast-bottom-center'
    }
    this.toastr.info(message, undefined, toasterConfig);
  }

  showWarning(message: any, title?: any) {
    let toasterConfig = {
      positionClass: 'toast-bottom-center'
    }
    this.toastr.warning(message, undefined, toasterConfig);
  }



  // **************************************************sweet alert code start*******************************************
  // enable subscribing to alerts observable

  async toast(
    typeIcon: SweetAlertIcon = 'success',
    timerProgressBar: boolean = false,
    qrData: string
  ) {
    // Create the component dynamically
    const componentFactory = this.resolver.resolveComponentFactory(QrModalComponent);
    this.dynamicComponentRef = componentFactory.create(this.injector);
    this.dynamicComponentRef.instance.qrData = qrData;
    this.appRef.attachView(this.dynamicComponentRef.hostView);

    // Create a div and append the component's root element
    const div = document.createElement('div');
    // Create a new div for the buttons
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'button-container d-flex justify-content-center'; // Add a class for styling

    // Create the close button with icon
    const closeButton = document.createElement('button');
    closeButton.innerHTML = '<i class="fas fa-times"></i>';
    closeButton.className = 'swal-custom-button swal-close-button btn btn-danger-outline w-100';

    // Create another button with HTML content
    const anotherButton = document.createElement('button');
    anotherButton.innerHTML = '<i class="fas fa-compress-arrows-alt"></i>';
    anotherButton.className = 'swal-custom-button swal-max-button ml-2  btn btn-primary-outline w-100';


    div.appendChild((this.dynamicComponentRef.hostView as any).rootNodes[0]);
        // Append the buttons to the button container div
        buttonContainer.appendChild(closeButton);
        buttonContainer.appendChild(anotherButton);
    
       // Append the button container to the main div
        div.appendChild(buttonContainer);

    // Show the SweetAlert toast
    await Swal.fire({
      html: div,
      confirmButtonText: 'Anartz',
      focusConfirm: false,
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timerProgressBar,
      title: 'Scan QR Code',
      didOpen: () => {
        // Handle toast container click
        const swalContainer = Swal.getContainer();
        swalContainer?.addEventListener('click', () => {
          this.actionDynamicComponent();
        });

        // Handle close button click
        closeButton.addEventListener('click', (event) => {
          event.stopPropagation(); // Prevent the toast click event
          Swal.close();
          this.cleanupDynamicComponent();
        });

        // Handle another button click
        anotherButton.addEventListener('click', (event) => {
          event.stopPropagation(); // Prevent the toast click event
          this.actionDynamicComponent();
        });
      },
    });
  }
  
  cleanupDynamicComponent() {
    Swal.close();
    if (this.dynamicComponentRef) {
      // Clean up the dynamically created component
      this.appRef.detachView(this.dynamicComponentRef.hostView);
      this.dynamicComponentRef.destroy();
      this.dynamicComponentRef = null;
    }
  }

  actionDynamicComponent(){
    this.cleanupDynamicComponent();
    AppData.goToDashboard.next(true);
    console.log("current route ",this.router.url)
    if(this.router.url == '/products/qr'){
      AppData.qrCalled.next(true);
    }
    
    this.router.navigate(['products/qr']); // Navigate on click
  }
  // async toast(
  //   typeIcon: SweetAlertIcon = 'success',
  //   timerProgressBar: boolean = false,
  //   qrData: string
  // ) {
  //   // Create the component dynamically
  //   const componentFactory = this.resolver.resolveComponentFactory(QrModalComponent);
  //   const componentRef = componentFactory.create(this.injector);
  //   componentRef.instance.qrData = qrData;
  //   this.appRef.attachView(componentRef.hostView);

  //   // Create a div and append the component's root element
  //   const div = document.createElement('div');
  //   div.appendChild((componentRef.hostView as any).rootNodes[0]);

  //   // Show the SweetAlert modal
  //   await Swal.fire({
  //     title: 'QR Code',
  //     html: div,
  //     showCancelButton: true,
  //     confirmButtonText: 'Anartz',
  //     focusConfirm: false,
  //     toast: true,
  //     position: 'bottom-end',
  //     showConfirmButton: false,
  //     // icon: typeIcon,
  //     timerProgressBar,
  //   });

  //   // Clean up the dynamically created component
  //   this.appRef.detachView(componentRef.hostView);
  //   componentRef.destroy();
  //   qrData='';
  // }

  // toast(typeIcon: SweetAlertIcon = 'success', timerProgressBar: boolean = false, qrData: string) {
  //   console.log(qrData)
  //   Swal.fire({
  //     title: 'Multiple inputs',
  //     html:
  //       '<input id="swal-input1" class="swal2-input">' +
  //       ` <ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="qrData"
  //       alt="Demo QR Code" class="qr-img" id="swal-input2">
  //     </ngx-qrcode>`,
  //     // showConfirmButton: true,
  //     showCancelButton: true,
  //     confirmButtonText: 'Anartz',
  //     focusConfirm: false, //No poner el foco en el botóón de confirmar
  //     preConfirm: () => {
  //       const val1 = (
  //         document.getElementById('swal-input1') as HTMLInputElement
  //       ).value;
  //       return [
  //         (document.getElementById('swal-input1') as HTMLInputElement).value,
  //         (document.getElementById('swal-input2') as HTMLInputElement).value,
  //       ];
  //     },
  //     toast: true,
  //     position: 'bottom-end',
  //     showConfirmButton: false,
  //     icon: typeIcon,
  //     timerProgressBar,
  //     // timer: 5000,
  //     // title: 'Signed in successfully',
  //   });
  // }


  onAlert(id = this.defaultId): Observable<Alert> {
    return this.subject.asObservable().pipe(filter((x) => x && x.id === id));
  };
  

  // convenience methods
  // success(message: string, options?: AlertOption) {
  //   // this.alert(new Alert({ ...options, type: AlertType.Success, message }));
  //   Swal.fire({
  //     toast: true,
  //     position: 'bottom',
  //     title: message,
  //     timer: 2000, //options?.timer,
  //     timerProgressBar: true, //options?.timer ? true : false,
  //     icon: 'success',
  //     showConfirmButton: options?.showConfirmButton,
  //     showCloseButton: true,
  //     // showClass: {
  //     //   popup: 'animate__slideInRight'
  //     // },
  //     // hideClass: {
  //     //   popup: 'animate__slideOutRight'
  //     // }
  //   });
  // };

  // error(message: string, options?: AlertOption) {
  //   // this.alert(new Alert({ ...options, type: AlertType.Error, message }));
  //   Swal.fire({
  //     // title: 'Error!',
  //     text: message,
  //     timer: options?.timer,
  //     timerProgressBar: options?.timer ? true : false,
  //     icon: 'error',
  //     showConfirmButton: options?.showConfirmButton,
  //     showCloseButton: true,
  //     backdrop: !options?.allowOutsideClick,
  //     allowOutsideClick: options?.allowOutsideClick || true,
  //     // showClass: {
  //     //   backdrop: 'swal2-backdrop-show'
  //     // },
  //     // hideClass: {
  //     //   popup: 'animate__bounceOut'
  //     // }
  //   })
  //   return false;
  // };
  // errorHtml(message: string, options?: AlertOption) {
  //   // this.alert(new Alert({ ...options, type: AlertType.Error, message }));
  //   Swal.fire({
  //     // title: 'Error!',
  //     html: message,
  //     timer: options?.timer,
  //     timerProgressBar: options?.timer ? true : false,
  //     icon: 'error',
  //     showConfirmButton: options?.showConfirmButton,
  //     showCloseButton: true,
  //     backdrop: !options?.allowOutsideClick,
  //     allowOutsideClick: options?.allowOutsideClick || true,
  //     // showClass: {
  //     //   backdrop: 'swal2-backdrop-show'
  //     // },
  //     // hideClass: {
  //     //   popup: 'animate__bounceOut'
  //     // }
  //   })
  //   return false;
  // };

  // info(message: string, options?: AlertOption) {
  //   //this.alert(new Alert({ ...options, type: AlertType.Info, message }));
  //   Swal.fire({
  //     // title: 'Error!',
  //     text: message,
  //     timer: options?.timer,
  //     timerProgressBar: options?.timer ? true : false,
  //     icon: 'info',
  //     showConfirmButton: options?.showConfirmButton,
  //     showCloseButton: true,
  //     // showClass: {
  //     //   popup: 'animate__bounceIn'
  //     // },
  //     // hideClass: {
  //     //   popup: 'animate__bounceOut'
  //     // }
  //   });
  // };
  // successalert(message: string, options?: AlertOption) {
  //   //this.alert(new Alert({ ...options, type: AlertType.Warning, message }));
  //   Swal.fire({
  //     // title: 'Error!',
  //     text: message,
  //     timer: options?.timer,
  //     timerProgressBar: options?.timer ? true : false,
  //     icon: 'success',
  //     showConfirmButton: options?.showConfirmButton,
  //     showCloseButton: true
  //     // showClass: {
  //     //   popup: 'animate__bounceIn'
  //     // },
  //     // hideClass: {
  //     //   popup: 'animate__bounceOut'
  //     // }
  //   })
  // };

  // warn(message: string, options?: AlertOption) {
  //   //this.alert(new Alert({ ...options, type: AlertType.Warning, message }));
  //   Swal.fire({
  //     // title: 'Error!',
  //     text: message,
  //     timer: options?.timer,
  //     timerProgressBar: options?.timer ? true : false,
  //     icon: 'warning',
  //     showConfirmButton: options?.showConfirmButton,
  //     showCloseButton: true,
  //     // showClass: {
  //     //   popup: 'animate__bounceIn'
  //     // },
  //     // hideClass: {
  //     //   popup: 'animate__bounceOut'
  //     // }
  //   });
  // };

  // main alert method
  alert(alert: Alert) {
    alert.id = alert.id || this.defaultId;
    this.subject.next(alert);
  };

  // clear alerts
  clear(id = this.defaultId) {
    this.subject.next(new Alert({ id }));
  };

  // alertwithtml(message: string, options?: AlertOption, callback?: any) {
  //   Swal.fire({
  //     title: '<strong>Successful</strong>',
  //     icon: 'success',
  //     html: message,
  //     showCloseButton: true,
  //     showCancelButton: false,
  //     focusConfirm: false,
  //     confirmButtonText: 'OK',
  //     backdrop: !options?.allowOutsideClick,
  //     allowOutsideClick: options?.allowOutsideClick || true,
  //   }).then((result) => {
  //     if (result?.isConfirmed) {
  //       console.log(result);

  //     }
  //   });
  // };
  // **************************************************sweet alert code end***************************************************

}

// **************************************************sweet alert classess and interface*******************************************
export class Alert {
  id?: string;
  type: AlertType = 2;
  message?: string;
  autoClose?: boolean;
  remove: number = 3000;
  keepAfterRouteChange?: boolean;
  fade?: boolean;
  constructor(init?: Partial<Alert>) {
    Object.assign(this, init);
  }
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}

export interface AlertOption {
  icon?: 'warning' | 'error' | 'success' | 'info' | 'question';
  showConfirmButton?: boolean;
  confirmButtonText?: string;
  timer?: number;
  timerProgressBar?: boolean;
  allowOutsideClick?: boolean;
}

// **************************************************sweet alert classess and interface*******************************************



